import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PaymentStatusPipe'
})
export class PaymentStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Pending',
    1: 'Cleared',
    2: 'Pending Payout',
    3: 'Paid'
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
